/* LOVEQUEEN - Logo Link Fix
 * ロゴクリックでトップに戻ることを保証
 */
(function () {
  'use strict';

  function ensureLogoLink() {
    document.querySelectorAll('.header--logo, .header-mobile-logo, .header-desktop-logo').forEach(function (el) {
      if (el.dataset.lqLogoBound) return;
      el.dataset.lqLogoBound = '1';
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; // 既存<a>クリックは尊重
        e.preventDefault();
        window.location.href = '/';
      });
    });

    // 既存の <a href="/"> のクリックを保証 (preventDefault されてる場合の保険)
    document.querySelectorAll('.header--logo a[href="/"], a.header__logo[href="/"]').forEach(function (a) {
      a.style.cursor = 'pointer';
      a.style.pointerEvents = 'auto';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureLogoLink);
  } else {
    ensureLogoLink();
  }
  document.addEventListener('shopify:section:load', ensureLogoLink);
})();
